import { render } from "./CalendarEvent.vue?vue&type=template&id=49aafd5f"
import script from "./CalendarEvent.vue?vue&type=script&lang=js"
export * from "./CalendarEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__